export function getDailyChallengeTimesByVipLevel(vipLevel: number) {
  if (vipLevel <= 0) return 5
  if (vipLevel === 1) return 8
  if (vipLevel === 2) return 9
  return 10
}

export function getDailyChallengeTimesGrowth(currentVipLevel: number, nextVipLevel: number) {
  return getDailyChallengeTimesByVipLevel(nextVipLevel) - getDailyChallengeTimesByVipLevel(currentVipLevel)
}
